import "./portfolio.css";
import CreatableSelect from "react-select/creatable";
import React, { useState ,useRef} from 'react';
import Tooltip from '@mui/material/Tooltip';
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import { Link as RouterLink } from 'react-router-dom';
import Divider from "@mui/material/Divider";
import LoginPopUp from '../loginpopup';
import {ReactComponent as NotificationIcon} from "../../pages/account/profile/profile_icon/notification-icon.svg";
import {Link} from "react-router-dom";
import UserAvatar from "../userAvatar.js";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
  import { Tabs, Tab } from '@mui/material';
import Drawer from "@mui/material/Drawer";
import { ButtonGroup } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import MenuList from "../../includes/menulist";
import MenuListHome from "../../includes/menuListHome";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { EditText } from "react-edit-text"; // Import EditText component
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import { useEffect } from "react";
import { Card, Button, Grid, TextField } from "@mui/material";
import Modal from "@mui/material/Modal";
import Snackbar from "@mui/material/Snackbar";
import { updatePrivacy } from "../../apihelper/profile.js";

import Alert from "@mui/material/Alert";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import InputAdornment from "@mui/material/InputAdornment";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import json2mq from "json2mq";
import useMediaQuery from "@mui/material/useMediaQuery";
import LoadingButton from "@mui/lab/LoadingButton";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
// import { getCryporCurrencyList } from "../../apihelper/cryptocurrencylist";
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { getsymbollink } from "../../apihelper/getsymbollink.js";
import CircularProgress from "@mui/material/CircularProgress";
import BarChartIcon from '@mui/icons-material/BarChart';
import { Dialog, DialogTitle,BottomNavigationAction,BottomNavigation, DialogContent, DialogActions } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getPortfolioData,getmultiPortfolio } from "../../apihelper/portfolio";
import { addToPortfolio,RenamePortfolio,updateProfilePhoto } from "../../apihelper/portfolio";
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';
import AddIcon from '@mui/icons-material/Add';
import Portfolioadd from "../addPage/portfolioadd";
import SidebarMenuList from "../../includes/sidebarMenuList";
import { getCryporCurrencyList,getTotalunit,getFetchdropdown } from "../../apihelper/cryptocurrencylist";
import 'react-edit-text/dist/index.css';
import WatchListGallery from "../home/watchlistgallery.js";
import { useLocation } from "react-router-dom";
import Footer from '../footer';
const useStyles = styled((theme) => ({
  tableContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  table: {
    display: "none", // Hide the table on all screens
    [theme.breakpoints.down("sm")]: {
      display: "table", // Show the table on small screens only (mobile view)
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide the card container on small screens (mobile view)
    },
  },
  card: {
    width: "100%",
    margin: "8px",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px", // Adjust the card width as needed
    },
  },
}));




const drawerWidth = 292;
const existingOptions = [
  { value: 'Category A', label: 'Category A' },
  { value: 'Category B', label: 'Category B' },
  { value: 'Category C', label: 'Category C' },
];
const PortfolioWatchlist = (props) => {

  const [openModal, setOpenModal] = useState(false);
  const [portfolioTypeId, setPortfolioTypeId] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null); // State to store selected file
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
  const handleLoginClick = () => {
    // Mask the URL by adding /login at the end without navigating
    window.history.pushState({}, "", "/login");
    localStorage.setItem("isPopupManuallyOpened", "true");
    // Open the login modal
    setLoginModalOpen(true);
  };
  const handleModalClose = () => {
    // Close the modal and reset the URL to the welcome page
    setLoginModalOpen(false);
    navigate(location.pathname, { replace: true });
  };

  const navigate = useNavigate();
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [open, setOpen] =useState(false);

  const handleClose = () => setOpen(false);

  const [snackbaropen, setSnackbaropen] = useState(false);

  const [alignment, setAlignment] = useState("left");
  const [loader, setLoader] = useState(false);
  const [slugdata, setSlugdata] = useState([]);
  const [index, setIndex] = useState(0);
  const [addMoreLoader, setAddMoreLoader] = useState(false);
  const [portfolioname, setPortfolioname] = useState('');
  const [filter, setFilter] = useState("");
  const [loaderbutton, setLoaderButton] = useState(true);
  const [roivalue, setRoivalue] = useState("--");
  const [portfoliovalue, setPortfoliovalue] = useState("--");
  const [lastUpdatedTime, setLastUpdatedTiem] = useState("");
  const [portfolioid, setportfolioid] = useState("");
  const [options, setOptions] = useState([]);
  const [dropDown, setdropDown] = useState([]);
  const [newOptionValue, setNewOptionValue] = useState('');
  const [selectedOption, setSelectedOption] = useState([]);
  const [slugpopupdata, setSlugpopupdata] = useState({
    slugname: "",
    slug: "",
    units: 0,
  });

  
  const [msgAfterLoading, setMsgAfterLoading] = useState("");
  const [unit, setUnit] = useState("");
  const [buySell, setbuySell] = React.useState("");
  const [price, setPrice] = useState("");

  const [selectedDate, handleDateChange] = useState("");
  const [msgforUpdatePortfolio, setMsgforUpdatePortfolio] =
    useState("loading...");
  const [severity, setSeverity] = useState("info");
  const [initialPage, setInitialPage] = useState(false);
  const [localUserData,setLocalUserData]=useState(undefined)
  const [loaderForSymbolLink,setLoaderForSymbolLink]=useState(false);
  const [dataslug, setdataslug] = useState('');
  const [totalUnits, setTotalUnits] = useState(0); 
  const [Usablewallet, setUsablewallet] = useState("");
  const [user_role, setuser_role] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const location = useLocation(); 
  const loc = location.pathname;


  const [lockStatus, setLockStatus] = useState({});

  // // Retrieve saved lock state from localStorage when the component mounts
  // useEffect(() => {
  //   const savedLockStatus = JSON.parse(localStorage.getItem('lockStatus')) || {};
  //   setLockStatus(savedLockStatus);
  // }, []);
  

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    if (userData) {
      const user_id = userData.user_id;
      const token = userData.token;
  
      // Fetch current privacy data
      updatePrivacy({
        user_id,
        token,
        action: '' // Assuming this fetches the current lock status
      })
        .then((res) => {
          if (res.code === "200") {
            // Initialize lock status
            const newLockStatus = {};
  
            // Process the private portfolios
            const privatePortfolios = res.data.private_prtfs;
            if (privatePortfolios) {
              // Convert the comma-separated string into an array of IDs
              const lockedPortfolioIds = privatePortfolios.split(',').map(id => parseInt(id, 10));
  
              // Set the lock status for each portfolio type ID
              lockedPortfolioIds.forEach(id => {
                newLockStatus[id] = true;
              });
            }
  
            // Update state and localStorage
            setLockStatus(newLockStatus);
            localStorage.setItem("lockStatus", JSON.stringify(newLockStatus));
          } else {
            console.log("Error fetching data");
          }
        })
        .catch((err) => {
          console.error("API Error:", err);
        });
    }
    
  }, []);
  
  

  // Function to toggle lock status based on portfolio_type_id and update localStorage
  const handleLockClick = (portfolio_type_id) => {
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    if (!userData) {
      console.error("User data not found");
      return;
    }

    const user_id = userData.user_id;
    const token = userData.token;

    // Toggle the lock state for this portfolio type
    setLockStatus((prevState) => {
      const isLocked = prevState[portfolio_type_id];

      // Toggle lock state for the given portfolio_type_id
      const updatedLockStatus = {
        ...prevState,
        [portfolio_type_id]: !isLocked, // Toggle lock/unlock state
      };

      // Save the updated lock status to local storage
      localStorage.setItem("lockStatus", JSON.stringify(updatedLockStatus));

      // Update the privacy status in the backend
      updatePrivacy({
        user_id,
        portfolio_type_id,
        token,
        action: isLocked ? 'remove' : 'add', // Determine if we are adding or removing the lock
      })
        .then((res) => {
          if (res.code === "200") {
            console.log("Privacy updated successfully:", res.data);
          } else {
            console.error("Error in API response:", res.message);
          }
        })
        .catch((err) => {
          console.error("API Error:", err);
        });

      return updatedLockStatus; // Return the updated state immediately
    });
  };
  const handleButtonClick_ = () => {
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const fetchDropdownOptions = async () => {
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    console.log("User ID : ", userData.user_id);


    getFetchdropdown({
      user_id: userData.user_id,
      
      Token:userData.token
    }).then((res) => {
      if (res.code === "200") {
        console.log("Data of fetchdropdown: ",res.data);
        const newOptions = res.data.map(item => ({ value: item.id, label: item.name }));
          setOptions(newOptions);
          setuser_role(res.user_role);
       } else {
        console.log("Data fething error");
      }
    
    });
   
    
  }
  const handleChange = async (selectedOption) => {
    if (selectedOption && selectedOption.__isNew__) {
  
      console.log('Creating new option:', selectedOption.value);
      setSelectedOption(null);

    } 
    else if(!selectedOption) {
      // Handle the case when the selection is cleared
      setSelectedOption(null);
      
      // Perform any other necessary actions
      return;
    }else{
    setSelectedOption(selectedOption);
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
  }
  };


  const handleCreate = async (inputValue) => {

    if (options.find(option => option.value === inputValue)) {
      return; // Exit early if the option already exists
    }
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    //console.log(inputValue);
    const newOption = { value: inputValue, label: inputValue };
    const newOptions = [...options, newOption]; // Create a new array with the existing options plus the new one
    setOptions(newOptions); // Update the options state
    const createdOption = newOptions.find(option => option.value == inputValue);
   // console.log(createdOption);
    if (createdOption) {
      handleChange(createdOption);
    }
   
  };
  
  

  const handleSymbolLink=(symbolName)=>{
    //console.log(symbolName)
    setLoaderForSymbolLink(true);
    getsymbollink(symbolName).then(res=>{
      if(res.code==='200')
      window.open(res.article_link, '_blank', 'noreferrer');
      // window.location.replace(res.article_link);
      // setLoaderForSymbolLink(false);
      setLoaderForSymbolLink(false);
    })
  }
  

  useEffect(() => {
    if (dropDown) {
      fetchDropdownOptions();
    }
  }, [dropDown]);

  const handleOpenSelect = () => {
    setdropDown(true);
  };

  

  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );
  var rows = [],
    i = 0,
    len = 15;
  while (++i <= len) rows.push(i);
  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  

  const resetSelectedFile = () => {
    setSelectedFile(null);
  };

 
  const [rowsToShow, setRowsToShow] = useState(7);

  const handleLoadMore = () => {
    setRowsToShow(rowsToShow + 4);
  };

  // const loadMore = () => {
  //   // setLoader(false);
  //   setAddMoreLoader(true);
  //   setIndex(index + 10);
  //   //console.log(index);
  //   const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
  //   getmultiPortfolio({
  //     slug: filter,
  //     user_id: userData.user_id,
  //     start_index: index + 10,
  //     limit: `${10}`,
  //     Token: userData.token,
  //   }).then((res) => {
  //     if (res.code === "200") {
  //       //console.log("data got successfully");
  //       setSlugdata([...slugdata, ...res.data]);
  //       //console.log(res.data);
  //       if (res.data.length < 10) {
  //         //console.log("change Loaderbutton");
  //         setLoaderButton(false);
  //       } else {
  //         setLoaderButton(true);
  //       }
  //       setLoader(true);
  //       setAddMoreLoader(false);
  //     } else {
  //       //console.log("Data fething error");
  //     }
  //     // console.log(slugdata)
  //   });
  // };
  const [isRowClicked, setIsRowClicked] = useState(false);

  const closesnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbaropen(false);
  };
  const handleClick = () => {
    setSnackbaropen(true);
    setOpen(true);
    setSeverity("info");
    // setSnackbarcolor("success");
    // setSnackbarmessage("Data saved successfully");
    setMsgforUpdatePortfolio("loading...");
    //console.log(price, selectedDate, buySell, unit);
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    addToPortfolio({
      user_id: userData.user_id,
      slug: slugpopupdata.slugname,
      unit: unit,
      acquisition_price: price,
      date_time: selectedDate,
      type: buySell,
      Token: userData.token,
    }).then((res) => {
      if (res.code === "200") {
        setOpen(false);
        setSeverity("info");
        //console.log(res.message);
        setMsgforUpdatePortfolio(res.message);
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        setLoader(false);
        getPortfolioData({
          slug: filter,
          user_id: userData.user_id,
          start_index: `${index}`,
         
          Token: userData.token,
        }).then((res) => {
          if (res.code === "200") {
            //console.log("data got successfully");
            setSlugdata(res.data);
            // console.log(res.data)
            if (res.data.length === 0) {
              setInitialPage(true);
            }
            if (res.data.length < 20) {
              setLoaderButton(false);
            } else {
              setLoaderButton(true);
            }
            setLoader(true);
            setAddMoreLoader(false);
          } else {
            //console.log("Data fething error");
          }
          // console.log(slugdata)
        });
        setUnit("");
        setbuySell("");
        setPrice("");
        handleDateChange("");
        //navigate("/portfolio");
      } else {
        setSeverity("error");
        // setOpen(true)
        setMsgforUpdatePortfolio(res.message);
      }
    });
  };
  


  
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const container =
    window1 !== undefined ? () => window().document.body : undefined;

  // useEffect(() => {
  //   // Perform localStorage action
  //   const item = localStorage.getItem('userdata')
  //   if (item ==null){
  //      setredirectpage(true);
  //   }
  //   //console.log("tapan"+item);
  // }, [])
  // if (redirectpage) {

  //   return redirect('/');
  // }

  const drawer = (
    <div className="d-flex flex-column h-100" style={{overflowY:'hidden'}}>
      <SidebarMenuList/>
    </div>
  );

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
      border: 0,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      border: 0,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // hide last border
   
    "& td, & th": {
      border: 0,

    },
  }));

  
  const handleSave = async (portfolioname,portfolio_id) => {
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    RenamePortfolio({
      user_id: userData.user_id,
      portfolio_id: portfolio_id,
      portfolio_name: portfolioname,
      Token: userData.token,
    }).then((res) => {
      if (res.code == "200") {
        return;
      } else {
       // console.log(res.message);
       setSeverity("error")
      setMsgforUpdatePortfolio(res.message);
        setSnackbaropen(true);
      }
    });
  };

  
  
  const [selectedButton, setSelectedButton] = useState("CoinPrices");
  const [isTableView, setIsTableView] = useState(true);
  const handleButtonClick = (buttonName) => {
    // If the same button is clicked again, don't toggle the view
    if (selectedButton === buttonName) {
      return;
    }

    // Toggle the view based on the clicked button
    setSelectedButton(buttonName);
    setIsTableView(buttonName === "CoinPrices" ? false : true); // Show table view only if 'CoinPrices' is selected
  };
 
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');


  const [sortOrder, setSortOrder] = useState({ // Track ascending/descending for each column
    roi : 'asc',
    profit : 'asc'
  });
  const [sortType, setSortType] = useState('roi_asc');

  const handleSort = (column) => {
    console.log("Arrow Clicked");
    const newSortOrder = sortOrder[column] === 'asc' ? 'desc' : 'asc'; // Toggle sort order
    setSortOrder({ ...sortOrder, [column]: newSortOrder });

    console.log("Sorted");
  
    // Set the sort type based on the column
    switch (column) {
      case 'roi':
        setSortType(newSortOrder === 'asc' ? 'roi_asc' : 'roi_desc');
        break;

      case 'profit':
          setSortType(newSortOrder === 'asc' ? 'profit_asc' : 'profit_desc');
          break;
      
      default:
        break;
    }
  };

  //console.log("Data : ", data);
  // Helper function to convert net profit to a number
  const convertNetProfit = (profit) => {
    const number = parseFloat(profit.replace(/[^0-9.-]+/g, '')); // Remove $ sign and commas
    return isNaN(number) ? 0 : number; // Handle invalid or empty values
  };
  

  const filteredData = data.filter(portfolio => 
    portfolio.total_net_profit !== null && 
    portfolio.total_net_profit !== undefined && 
    !isNaN(convertNetProfit(portfolio.total_net_profit))
  );
  
  //console.log("Filtered Data: ", filteredData);
  
  // Helper function to convert ROI value to a number
  const convertRoiValue = (roi) => {
    const number = parseFloat(roi.replace('%', ''));
    return isNaN(number) ? 0 : number; // Handle invalid or empty values
  };
  
  
  const sortedData = [...filteredData].sort((a, b) => {
    switch (sortType) {
      case 'roi_asc':
        return convertRoiValue(a.roi_value) - convertRoiValue(b.roi_value);
      case 'roi_desc':
        return convertRoiValue(b.roi_value) - convertRoiValue(a.roi_value);
      
      case 'profit_asc':
        return convertNetProfit(a.total_net_profit) - convertNetProfit(b.total_net_profit);
      case 'profit_desc':
        return convertNetProfit(b.total_net_profit) - convertNetProfit(a.total_net_profit);
       
      default:
        return 0;
    }
  });
  
  //console.log("Sorted Data: ", sortedData);
  

  const [unreadAlerts, setUnreadAlerts] = useState(0);
    useEffect(() => {
    
                const userId = userData?.user_id || null;
    
                const fetchAlertsCount = async () => {
                  try {
                      const formData = new URLSearchParams();
                      formData.append("user_id", userId); // convert to form-encoded format
              
                      const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/crypto_alerts_count", {
                          method: "POST",
                          headers: {
                              "Content-Type": "application/x-www-form-urlencoded", // ✅ no preflight
                          },
                          body: formData, // ✅ correct format for this content type
                      });
              
                      if (!response.ok) {
                          throw new Error(`Error: ${response.status}`);
                      }
              
                      const data = await response.json();
                      console.log(data);
                      setUnreadAlerts(data.unread_notifications);
                  } catch (error) {
                      console.error("Failed to fetch alerts:", error);
                  }
              };
              
                fetchAlertsCount();
              }
              , []);

  const EditButton = () => {
    

    
    

  
    return (
      <>
      <Helmet>
        <title>My Portfolios</title>
      </Helmet>
     
       

      </>
    );
  };

  const [path, setPath] = useState("/");
              
  useEffect(() => {
                 if (typeof window !== "undefined") {
                   setPath(window.location.pathname);
                 }
               }, []);

               const TopNavigationDesktop = ({ unreadAlerts }) => {


                   const isActive = (href) => path === href;
                 
                   const topTabStyle = (active) => ({
                     display: "flex",
                     alignItems: "center",
                     padding: active? "5px 13px" : "2px 13px",
                     borderRadius: "999px",
                     backgroundColor: active ? "#ffffff" : "transparent",
                     color: active ? "#1877F2" : "#ffffff",
                     fontWeight: active ? "600" : "500",
                     fontSize: "16px",
                     cursor: "pointer",
                     border: active ? "2px solid #ffffff" : "none",
                   });
                 
                   const iconFilter = (active) =>
                     active
                       ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                       : "brightness(0) invert(1)";
                 
                   return (
                     <div style={{ padding: "20px", background: "#ffffff" }}>
                       {/* Top Navigation */}
                       <div
                         style={{
                           display: "flex",
                           justifyContent: "space-between",
                           alignItems: "center",
                           margin: "0 auto",
                         }}
                       >
                         {/* Left Tabs */}
                         <div
                           style={{
                             display: "flex",
                             alignItems: "center",
                             gap: "8px",
                             backgroundColor: "#1877F2",
                             padding: "5px 5px",
                             borderRadius: "50px",
                           }}
                         >
                           {/* My Profile */}
                           <Link to="/portfolio-gallery" style={{ textDecoration: "none" }}>
                             <div style={topTabStyle(isActive("/portfolio-gallery"))}>
                               <img
                                 src={window.constants.asset_path + "/images/home-new.svg"}
                                 alt="home"
                                 style={{
                                   marginRight: "6px",
                                   filter: iconFilter(isActive("/portfolio-gallery")),
                                 }}
                               />
                              Top Portfolios
                             </div>
                           </Link>
                 
                           {/* My Portfolio */}
                           <Link to={userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio"} style={{ textDecoration: "none" }}>
             <div style={topTabStyle(isActive(userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio"))}>
               <img
                 src={window.constants.asset_path + "/images/portfolio_tab.svg"}
                 alt="portfolio"
                 style={{
                   marginRight: "6px",
                   filter: iconFilter(isActive(userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio")),
                 }}
               />
               {userData ? "My Portfolios" : "Portfolio Audit"}
             </div>
           </Link>
           
                 
                           {/* Farm Button - Always highlighted */}
                           <Link to="/portfolios/watchlist" style={{ textDecoration: "none", }}>
                             <div style={topTabStyle(isActive("/portfolios/watchlist"))}>
                               <img
                                 src={window.constants.asset_path + "/images/search-new-2.svg"}
                                 alt="portfolio"
                                 style={{
                                   marginRight: "6px",
               
                                   filter: iconFilter(isActive("/portfolios/watchlist")),
                                 }}
                               />
                               My Watchlist
                             </div>
                           </Link>
                         </div>
                 
                         {/* Notification Bell */}
                         <div style={{display:"flex",alignItems:"center", justifyContent:"flex-end",gap:"5px",marginRight:"15px"}}>

                    {/* Notification Bell */}
                    <div
                        onClick={() => (window.location.href = "/alerts")}
                        style={{position: "relative", cursor: "pointer"}}
                    >
                        <NotificationIcon className="notification-icon fa-2x" />
                        {/* Desktop */}
                        <div
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "2px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "20px": "27px",
                                    height: unreadAlerts < 100 ? "20px": "27px",
                                    borderRadius: "50%",
                                    fontSize: "11px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                                >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                                </div>
                    </div>

                     <UserAvatar/>
            </div>
                       </div>
                 
                       {/* Bottom Tabs */}
                       <div
                         style={{
                           display: "flex",
                           justifyContent: "center",
                           gap: "60px",
                           marginTop: "40px",
                         }}
                       >
                         {[
                           {
                             icon: window.constants.asset_path + "/images/subscription_tab.svg",
                             label: "My Subscriptions",
                             href: "/subscriptions",
                           },
                           {
                             icon: window.constants.asset_path + "/images/portfolio_tab.svg",
                             label: "Presale",
                             href: "/pre-sale",
                           },
                           {
                             icon: window.constants.asset_path + "/images/profile_tab.svg",
                             label: "My Profile",
                             href: "/account",
                           },
                         ].map((tab, i) => {
                           
                         const isProfileTab = tab.label === "My Profile";
           
                         const handleClick = (e) => {
                           if (isProfileTab && !userData) {
                             e.preventDefault(); // Prevent navigation
                             handleLoginClick();
                           }
                         };
                     
           
                         return (
                         <Link  to={tab.href}
                         key={i}
                         style={{ textDecoration: "none" }}
                         onClick={handleClick}>  <div
                               style={{
                                 display: "flex",
                                 alignItems: "center",
                                 padding: "10px 20px",
                                 borderRadius: "28px",
                                 background:
                                   "var(--linek, linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%))",
                                 color: "#1877F2",
                                 fontWeight: "700",
                                 border: "1px solid #1877F2",
                                 fontSize: "16px",
                                 cursor: "pointer",
                               }}
                             >
                               <img
                                 src={tab.icon}
                                 alt="icon"
                                 style={{ marginRight: "8px", height: "20px" }}
                               />
                               {tab.label}
                             </div>
                           </Link>
                         );
                         })}
                       </div>
                     </div>
                   );
                 };
                 const TopNavigationMobile = ({ unreadAlerts }) => {
                  
                   const isActive = (href) => path === href;
                 
                   const topTabStyle = (active) => ({
                     display: "flex",
                     alignItems: "center",
                     padding:  active ? "3px 6px" : "1px 6px",
                     borderRadius: "999px",
                     backgroundColor: active ? "#ffffff" : "transparent",
                     textAlign:"left",
                     color: active ? "#000" : "#ffffff",
                     fontWeight:  active ? "600" : "500",
                     fontSize: "12px",
                     cursor: "pointer",
                     border: active ? "2px solid #ffffff" : "none",
                    
                   });
                 
                   const iconFilter = (active) =>
                     active
                       ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                       : "brightness(0) invert(1)";
                 
                   return (
                     <div style={{ padding: "10px 5px", background: "#ffffff", boxShadow:"0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
                       {/* Top Navigation */}
                       <div
                         style={{
                           display: "flex",
                           justifyContent: "space-between",
                           alignItems: "center",
                           margin: 0,
                         }}
                       >
                         {/* Left Tabs */}
                         <div
                           style={{
                             display: "flex",
                             alignItems: "center",
                             gap: "0px",
                             backgroundColor: "#1877F2",
                             padding: "5px 5px",
                             borderRadius: "50px",
                             fontSize:"13px",
                             minWidth:"270px",
                             textAlign:"center",
                             marginRight:"10px"
                           }}
                         >
                           {/* My Profile */}
                           <Link to="/portfolio-gallery" style={{ textDecoration: "none" }}>
                             <div style={topTabStyle(isActive("/portfolio-gallery"))}>
                                <img
                                 src={window.constants.asset_path + "/images/home-new.svg"}
                                 alt="home"
                                 style={{
                                   marginRight: "2px",
                                   height:"25px",
                                   filter: iconFilter(isActive("/portfolio-gallery")),
                                 }}
                               />
                              Top Portfolios
                             </div>
                           </Link>
                 
                           {/* My Portfolio */}
                           <Link to={userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio"} style={{ textDecoration: "none" }}>
                             <div style={topTabStyle(isActive(userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio"))}>
                              <img
                 src={window.constants.asset_path + "/images/portfolio_tab.svg"}
                 alt="portfolio"
                 style={{
                   marginRight: "2px",
                    height:"15px",
                   filter: iconFilter(isActive(userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio")),
                 }}
               />
                            {userData ? "My Portfolios" : "Portfolio Audit"}
                             </div>
                           </Link>
                 
                           {/* Farm Button - Always highlighted */}
                           <Link to="/portfolios/watchlist" style={{ textDecoration: "none" }}>
                             <div style={topTabStyle(isActive("/portfolios/watchlist"))}>
                               <img
                                 src={window.constants.asset_path + "/images/search-new-2.svg"}
                                 alt="portfolio"
                                 style={{
                                   marginRight: "2px",
                                    height:"15px",
                                   filter: iconFilter(isActive("/portfolios/watchlist")),
                                 }}
                               />
                               Watchlist
                             </div>
                           </Link>
                         </div>
           
                         <div style={{display:"flex",alignItems:"center"}}>
                 
                         {/* Notification Bell */}
                         <div onClick={() => window.location.href = "/alerts"} style={{ position: "relative", marginTop:"3px" }}>
                           <NotificationIcon className="notification-icon fa-2x"/>
                            {/* Mobile */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "7px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "18px" : "24px",
                                    height: unreadAlerts < 100 ? "18px" : "24px",
                                    borderRadius: "50%",
                                    fontSize: "10px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "18px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                            >
                               {unreadAlerts < 100 ? unreadAlerts : "99+"}
                            </div>
                         </div>
                 
                         <IconButton
                       color="inherit"
                       aria-label="open drawer"
                       edge="end"
                       onClick={handleDrawerToggle}
                       sx={{ display: { sm: "none" } }}
                     >
                       <img
                         src="/images/menubar.svg"
                         alt="Menu Icon"
                         style={{
                           width: "24px",
                           height: "24px",
                           marginRight: "10px",
                           marginTop: "10px",
                         }}
                       />
                     </IconButton></div>
                       </div>
                        <UserAvatar/>
                 
                       {/* Bottom Tabs */}
                       <div
                         style={{
                           display: "flex",
                           justifyContent: "center",
                           gap: "15px",
                           marginTop: "25px",
                           marginLeft:"10px",
                           marginRight:"10px"
                         }}
                       >
                         {[
                           {
                             icon: window.constants.asset_path + "/images/subscription_tab.svg",
                             label: "Subscriptions",
                             href: "/subscriptions",
                           },
                           {
                             icon: window.constants.asset_path + "/images/portfolio_tab.svg",
                             label: "Presale",
                             href: "/pre-sale",
                           },
                           {
                             icon: window.constants.asset_path + "/images/profile_tab.svg",
                             label: "Profile",
                             href: "/account",
                           },
                         ].map((tab, i) => {
           
                           const isProfileTab = tab.label === "Profile";
           
                           const handleClick = (e) => {
                             if (isProfileTab && !userData) {
                               e.preventDefault(); // Prevent navigation
                               handleLoginClick();
                             }
                           };
                       
           
                           return (
                           <Link  to={tab.href}
                           key={i}
                           style={{ textDecoration: "none" }}
                           onClick={handleClick}>
                             <div
                               style={{
                                 display: "flex",
                                 alignItems: "center",
                                 padding: "6px 10px",
                                 borderRadius: "28px",
                                 background:
                                   "var(--linek, linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%))",
                                 color: "#1877F2",
                                 fontWeight: "700",
                                 border: "1px solid #1877F2",
                                 fontSize: "13px",
                                 cursor: "pointer",
                               }}
                             >
                               <img
                                 src={tab.icon}
                                 alt="icon"
                                 style={{ marginRight: "5px", height: "15px" }}
                               />
                               {tab.label}
                             </div>
                           </Link>
                         );
                 })}
                       </div>
                     </div>
                   );
                 };

  return (
    <>
    
    
    {mediaQueryVar===true?(   
    <Box
      sx={{
        display: "flex",
        flexDirection: mediaQueryVar === false ? "column" : "",
        height: '100vh',
      }}
      className="maindiv"
    >
               <div
                    style={{
                    position: "fixed",
                    top: 0,
                    left: drawerWidth, // aligns it to the right of the sidebar
                    width: `calc(100% - ${drawerWidth}px)`, // takes full width minus sidebar
                    backgroundColor: "#ffffff",
                    zIndex: 1000,
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    height:"100px"
                    }}
                >
            <TopNavigationDesktop unreadAlerts={unreadAlerts} />
            </div>

      <CssBaseline />
      <div className="windowheader">
        <AppBar
          position="fixed"
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <img
              src={window.constants.asset_path+'/images/logo_with_bg.png'}
              width={220}
              height={50}
              alt="CWLOGO"
              style={{ margin: "10px", borderRadius: "5px" }}
            />
          </Toolbar>
        </AppBar>
      </div>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: "white",
              color: "#727376",
              
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: "white",
              color: "#727376",
              
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          padding: "2vw",
          backgroundColor: "#EDF1F6",
          paddingTop:"200px"
        }}
      >
        {initialPage && <Portfolioadd />}
        {!initialPage && (
          <>
            <div className="windowheader">
              <Toolbar />
            </div>
            <Box sx={{ flexGrow: 1 }} style={{ marginBottom: "15px" }}>
         <Box sx={{ 
              border: "1px solid white",  
              borderRadius: "8px", 
              padding: "25px 25px", 
              marginLeft:"15px", 
              marginRight: "25px", 
              boxShadow: "0 2px 4px rgba(0,0,0,0)", 
              backgroundColor: "white" ,
              overflow: "auto",
              // Hide the scrollbar
              '&::-webkit-scrollbar': {
              display: 'none',
              },
               '-ms-overflow-style': 'none',  
               'scrollbarWidth': 'none'
              }}>

     <TextField
                 style={{
                   width: "35%",
                   borderRadius: "46px",
                   marginTop: mediaQueryVar ? "" : "0px",
                   fontFamily: "Satoshi, sans-serif",
                   marginRight: "25px",
                   marginLeft:"-10px",
                   border: "1px #b6b6b8 solid",
                   backgroundColor: "white",
                   paddingTop: "0px",
                   paddingBottom: "2px",
                   paddingLeft: "12px",
                   paddingRight: "30px",
                   marginBottom: "5px",
                   fontSize:"14px",
                   fontWeight:"400"
                 }}
                 size="small"
                 placeholder="Search Portfolios"
                 onChange={(e) => setFilter(e.target.value)}
                 value={filter}
                 InputProps={{
                   startAdornment: (
                     <InputAdornment position="start">
                       <img  width={13} height={13} src={window.constants.asset_path + '/images/search.svg'} alt="search Icon" />
                     </InputAdornment>
                   ),
                   style: {
                     border: "none", // Remove the border from the input
                   },
                 }}
                 sx={{
                   '& .MuiOutlinedInput-root': {
                     '& fieldset': {
                       borderColor: 'transparent', // Remove the border of the fieldset
                     },
                     '&:hover fieldset': {
                       borderColor: 'transparent', // Remove the border on hover
                     },
                     '&.Mui-focused fieldset': {
                       borderColor: 'transparent', // Remove the border when focused
                     },
                   },
                 }}
               />
      <WatchListGallery filter={filter} onButtonClick={handleButtonClick}/>
     </Box>
     </Box>
     </>
        )}
        {loaderForSymbolLink===true &&
         <div >
              <CircularProgress style={{position:"fixed",top:"40vh",left:"45vw"}}/>
          </div> 
          }
          
      </Box>
      {mediaQueryVar === false && (
        <div
          style={{
            position: "fixed",
            bottom: "0",
            backgroundColor: "white",
            width: "105%",
            zIndex: "100",
            marginLeft:"-10px"
          }}
        >
          <BottomNavigation showLabels>
  <BottomNavigationAction
        label="Top Portfolios"
        onClick={() =>
          navigate("/portfolio-gallery")
        }
        icon={<img src={loc === '/portfolio-gallery' ? "/images/dashboardS.svg" : "/images/dashboardU.svg"} />}
        
      />
      <BottomNavigationAction
        label="My Portfolios"
        onClick={() => {
          navigate(userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio");
        }}
        icon={<img src={loc === '/my-portfolio/detailed-portfolio-analysis' ? "/images/portfolioS.svg" : "/images/portfolioU.svg"}  />}
      />
    <BottomNavigationAction
              label="Crypto Screener"
              onClick={() => navigate("/crypto-screener")}
              icon={
                <img
                  src={
                    loc === "/crypto-screener"
                      ? "/images/portfolioS.svg"
                      : "/images/portfolioU.svg"
                  }
                  width={"20px"}
                  height={"20px"}
                />
              }
            />
</BottomNavigation>
        </div>
      )}
      {isLoginModalOpen && (
        <LoginPopUp 
          isLoginModalOpen={isLoginModalOpen}
          setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
          onClose={handleModalClose}
        />
      )}
    </Box>
    ):(

      <Box
  sx={{
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  }}
>

<div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0, // aligns it to the right of the sidebar
                  width: "100%", // takes full width minus sidebar
                  backgroundColor: "#ffffff",
                  zIndex: 1000,
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  height:"100px"
                }}
              >
               <TopNavigationMobile unreadAlerts={unreadAlerts} />
              </div>
<Helmet>
        <title>Portfolio Watchlist</title>
</Helmet>
  
  <Box
    component="nav"
    sx={{
      width: "100%", // Take full width on mobile
    }}
    aria-label="mailbox folders"
  >
    <Drawer
      container={container}
      variant="temporary"
      open={mobileOpen}
      onClose={handleDrawerToggle}
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        "& .MuiDrawer-paper": {
          width: drawerWidth, // Adjust width for mobile
          backgroundColor: "white",
          color: "#727376",
        },
      }}
    >
      {drawer}
    </Drawer>
  </Box>


  <Box
    component="main"
    sx={{
      flexGrow: 1,
      paddingTop:3,
      paddingBottom: 3,
      paddingLeft:3,
      paddingRight:0,
      backgroundColor: "white",
      paddingBottom: "2vw",
      minHeight: "100vh",
      marginRight:"6px",
      overflowY:"auto",
      marginTop:"130px",

    }}
    className="maindiv"
  >

        {initialPage && <Portfolioadd />}
        {!initialPage && (
          <>
           

           <TextField
                 style={{
                   width: "85%",
                   borderRadius: "46px",
                   marginTop: mediaQueryVar ? "" : "0px",
                   fontFamily: "Satoshi, sans-serif",
                   marginRight: "25px",
                   marginLeft:"-10px",
                   border: "1px #b6b6b8 solid",
                   backgroundColor: "white",
                   paddingTop: "0px",
                   paddingBottom: "2px",
                   paddingLeft: "12px",
                   paddingRight: "30px",
                   marginBottom: "5px",
                   fontSize:"14px",
                   fontWeight:"400"
                 }}
                 size="small"
                 placeholder="Search Portfolios"
                 onChange={(e) => setFilter(e.target.value)}
                 value={filter}
                 InputProps={{
                   startAdornment: (
                     <InputAdornment position="start">
                       <img  width={13} height={13} src={window.constants.asset_path + '/images/search.svg'} alt="search Icon" />
                     </InputAdornment>
                   ),
                   style: {
                     border: "none", // Remove the border from the input
                   },
                 }}
                 sx={{
                   '& .MuiOutlinedInput-root': {
                     '& fieldset': {
                       borderColor: 'transparent', // Remove the border of the fieldset
                     },
                     '&:hover fieldset': {
                       borderColor: 'transparent', // Remove the border on hover
                     },
                     '&.Mui-focused fieldset': {
                       borderColor: 'transparent', // Remove the border when focused
                     },
                   },
                 }}
               />
                
        
         <WatchListGallery filter={filter} onButtonClick={handleButtonClick}/>
                
          </>
        )}
        {loaderForSymbolLink===true &&
         <div >
              <CircularProgress style={{position:"fixed",top:"40vh",left:"45vw"}}/>
          </div> 
          }
          
      </Box>
      {mediaQueryVar === false && (
        <div
          style={{
            position: "fixed",
            bottom: "0",
            backgroundColor: "white",
            width: "100%",
            zIndex: "100",
            marginTop:"5px"
          }}
        >
          <BottomNavigation showLabels>
          <BottomNavigationAction
        label="Top Portfolios"
        onClick={() =>
          navigate("/portfolio-gallery")
        }
        icon={<img src={loc === '/portfolio-gallery' ? "/images/dashboardS.svg" : "/images/dashboardU.svg"} />}
        
      />
      <BottomNavigationAction
        label="My Portfolios"
        onClick={() => {
          navigate(userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio");
        }}
        icon={<img src={loc === '/my-portfolio/detailed-portfolio-analysis' ? "/images/portfolioS.svg" : "/images/portfolioU.svg"}  />}
      />
     <BottomNavigationAction
              label="Crypto Screener"
              onClick={() => navigate("/crypto-screener")}
              icon={
                <img
                  src={
                    loc === "/crypto-screener"
                      ? "/images/portfolioS.svg"
                      : "/images/portfolioU.svg"
                  }
                  width={"20px"}
                  height={"20px"}
                />
              }
            />
</BottomNavigation>
        </div>
      )}
      {isLoginModalOpen && (
        <LoginPopUp 
          isLoginModalOpen={isLoginModalOpen}
          setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
          onClose={handleModalClose}
        />
      )}
    </Box>
    )}
</>

  );
}

export default PortfolioWatchlist;